import {
  Component, OnDestroy, OnInit,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { AuthService } from 'src/app/services/auth.service';
import { EntityService } from 'src/app/services/entity.service';
import { UsersService } from 'src/app/services/users.service';

// TODO: we need to redesign the header
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: [ './header.component.scss' ],
})
export class HeaderComponent implements OnInit, OnDestroy {
  loggedInSubscription: Subscription;
  reloadLogoSub: Subscription;
  mobileNavIsOpen = false;
  loggedIn$: any = false;
  user$: Observable<any>;
  entity$: Observable<any>;
  logoSrc!: string;

  constructor(
    private authService: AuthService,
    private entityService: EntityService,  private usersService: UsersService,
  ) { }

  ngOnInit(): void {
    this.loggedInSubscription = this.authService.loggedIn$
      .subscribe((loggedInStatus: any) => {
        this.loggedIn$ = loggedInStatus
        if (loggedInStatus) {
          this.loadEntityLogo();
        }
      })
    this.user$ = this.authService.user$
    this.entity$ = this.authService.entity$
    this.reloadLogoSub = this.usersService.reloadLogo$.subscribe(() => this.loadEntityLogo());
  }

  loadEntityLogo(): void {
    this.authService.user$.subscribe(user => {
      if (user && user.loginName) {
        this.entityService.getEntityLogo(user.loginName).subscribe({
          next: (response: any) => {
            if (response && response.data && response.data.logoUrl) {
              this.logoSrc = response.data.logoUrl;
            }
          },
          error: (error) => {
            console.error('Failed to load entity logo:', error);
          },
        });
      }
    }).unsubscribe();
  }

  toggleMobileNav = () => {
    this.mobileNavIsOpen = !this.mobileNavIsOpen
  }

  logout = () => {
    this.authService.logout()
  }

  ngOnDestroy(): void {
    this.loggedInSubscription.unsubscribe()
    this.reloadLogoSub?.unsubscribe();
  }

}
